




























import {Component, Prop, Vue} from 'vue-property-decorator'
import {State, Action} from 'vuex-class'

@Component
export default class CardOne extends Vue {
  @State userConfig
  @Prop() private item!: object
  @Prop({default: 1}) type!: number
  @Prop() imgPos!: string
  @Action linkInterceptor
  content = '职称:教授\n' + '职务:基础医学院副院长\n' + '电话:0551-65161215\n' + '邮箱:fanghaoshu@ahmu.edu.cn'

  getDate(time: string | number) {
    let date = new Date(time) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
    return Y + M + D
  }

  get themeColor () {
    return '#' + (this.$route.query.pageColor || '3bb4d7')
  }
}
